import styled from 'styled-components';

export const StartedDescription = styled.p`
  margin: 10px 0;
  font-size: 1.2em;
  font-weight: 600;
  word-break: keep-all;
  line-height: 1.1;
`;
